import type { RootAction } from 'RootTypes';
import { getType } from 'typesafe-actions';

import * as Account from '../account';

import * as Actions from './actions';
import type {
    TeamMemberUser,
    Player,
    PlayerID,
    UserRolloverAssociation,
    PlayerRolloverAssocation,
    VideoClipID,
    PlayerVideoClip,
    AthleteProfile,
} from './types';

export const initialState: State = {
    teamMemberUsers: [],
    players: {},
    rolloverOptions: {
        fans: [],
        staff: [],
        players: [],
    },
    videoClipsByPlayerID: {},
};

interface State {
    teamMemberUsers: TeamMemberUser[];
    players: { [teamID: string]: Player[] };
    rolloverOptions: {
        fans: UserRolloverAssociation[];
        staff: UserRolloverAssociation[];
        players: PlayerRolloverAssocation[];
    };
    videoClipsByPlayerID: { [playerID: PlayerID]: { [id: VideoClipID]: PlayerVideoClip } };
    athleteProfile?: AthleteProfile;
}

export const reducer = (state = initialState, action: RootAction): State => {
    switch (action.type) {
        case getType(Account.Actions.logOut):
            return {
                ...initialState,
                athleteProfile: state.athleteProfile,
            };

        case getType(Actions.addTeamMemberUsers):
            return {
                ...state,
                teamMemberUsers: action.payload,
            };

        case getType(Actions.addPlayers):
            return {
                ...state,
                players: {
                    ...state.players,
                    [action.payload.teamID]: action.payload.players,
                },
            };

        case getType(Actions.addRolloverOptions):
            return {
                ...state,
                rolloverOptions: action.payload,
            };

        case getType(Actions.addPlayerVideoClips): {
            const asObject: {
                [id: VideoClipID]: PlayerVideoClip;
            } = {};
            action.payload.videoClips.forEach((clip) => {
                asObject[clip.id] = clip;
            });

            return {
                ...state,
                videoClipsByPlayerID: {
                    ...state.videoClipsByPlayerID,
                    [action.payload.playerID]: asObject,
                },
            };
        }
        case getType(Actions.setPlayerVideoClipUrl): {
            return {
                ...state,
                videoClipsByPlayerID: {
                    ...state.videoClipsByPlayerID,
                    [action.payload.playerID]: {
                        ...state.videoClipsByPlayerID[action.payload.playerID],
                        [action.payload.clipID]: {
                            ...state.videoClipsByPlayerID[action.payload.playerID][action.payload.clipID],
                            playbackUrl: action.payload.url,
                        },
                    },
                },
            };
        }
        case getType(Actions.setAthleteProfileAndClipsPublic): {
            return {
                ...state,
                athleteProfile: action.payload.athleteProfile,
            };
        }
        default:
            return state;
    }
};
